import { IsOnboardingParams } from "@simplyk/common";
import { useSearchParams } from "next/navigation";

export const useIsOnboarding = () => {
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams?.entries?.() || []);
  const params: IsOnboardingParams = query;
  const isOnboarding = params.isOnboarding === "true";

  return { isOnboarding };
};
